import React from 'react';

interface KiteIconProps {
  size?: number;
  className?: string;
  color?: string;
}

/**
 * Zerodha Kite Branded Geometric Polygon Icon
 */
export const KiteIcon: React.FC<KiteIconProps> = ({
  size = 16,
  className = '',
  color = '#e05338',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Top triangle */}
      <path
        d="M12 2L20 10H4L12 2Z"
        fill={color}
        fillOpacity="0.95"
      />
      {/* Bottom left facet */}
      <path
        d="M4 10L12 22V10H4Z"
        fill={color}
        fillOpacity="0.75"
      />
      {/* Bottom right facet */}
      <path
        d="M20 10L12 22V10H20Z"
        fill={color}
        fillOpacity="1"
      />
    </svg>
  );
};
